import { PageHeader } from '@/app/layouts/PageHeader'
import { AccessTabs, CopyField } from '@/features/access'
import { SettingsSection } from '@/features/settings'
import { useT } from '@/i18n'

const CONFIG = `{
  "mcpServers": {
    "plazaplus": {
      "command": "plazaplus-mcp",
      "env": {
        "PLAZAPLUS_API_KEY": "rex_sk_…",
        "PLAZAPLUS_BASE_URL": "${typeof window === 'undefined' ? '' : window.location.origin}"
      }
    }
  }
}`

/**
 * MCP 接入页。
 *
 * 和 AMCP 面向的是同一套能力，区别在协议：MCP 走 stdio、由客户端本地
 * 拉起进程；AMCP 走 HTTP、由 AgentPlus 的服务器回调。
 */
export function SettingsMcpPage() {
  const t = useT()
  return (
    <>
      <PageHeader title={t('settings.access')} subtitle={t('mcp.subtitle')} back>
        <AccessTabs />
      </PageHeader>

      <SettingsSection title={t('mcp.install')} description={t('mcp.installDesc')}>
        <CopyField value="pip install 'plazaplus[mcp]'" label={t('mcp.installLabel')} />
      </SettingsSection>

      <SettingsSection title={t('mcp.configure')} description={t('mcp.configureDesc')}>
        <CopyField multiline value={CONFIG} label={t('mcp.configLabel')} />
        <p className="mt-3 text-[13px] text-ink-muted">
          {t('mcp.keyNote1')}
          <strong>{t('access.tabKeys')}</strong>
          {t('mcp.keyNote2')}
        </p>
      </SettingsSection>

      <SettingsSection title={t('mcp.vsAmcp')}>
        <ul className="list-disc space-y-2 pl-5 text-[13px] text-ink-muted">
          <li>{t('mcp.point1')}</li>
          <li>{t('mcp.point2')}</li>
          <li>{t('mcp.point3')}</li>
        </ul>
      </SettingsSection>
    </>
  )
}
